export default {
  width: "100%",
  marginBottom: "10px"
};
